import { useToast } from "primevue/usetoast";
import { getCurrentInstance } from "vue";

type AlertOptions = {
  life?: number;
  closable?: boolean;
  group?: string;
};

export function useAlerts() {
  if (!getCurrentInstance()) {
    throw new Error("useAlerts() must be called from setup()");
  }
  const toast = useToast();

  const successToast = (summary: string, detail?: string, opts: AlertOptions = {}) => {
    toast.add({
      severity: "success",
      summary,
      detail,
      life: opts.life ?? 3000,
      closable: opts.closable ?? true,
      group: opts.group ?? "tr",
    });
  };

  const errorToast = (summary: string, detail?: string, opts: AlertOptions = {}) => {
    toast.add({
      severity: "error",
      summary,
      detail,
      life: opts.life ?? 4000,
      closable: opts.closable ?? true,
      group: opts.group ?? "tr",
    });
  };

  const warnToast = (summary: string, detail?: string, opts: AlertOptions = {}) => {
    toast.add({
      severity: "warn",
      summary,
      detail,
      life: opts.life ?? 3500,
      closable: opts.closable ?? true,
      group: opts.group ?? "tr",
    });
  };

  const infoToast = (summary: string, detail?: string, opts: AlertOptions = {}) => {
    toast.add({
      severity: "info",
      summary,
      detail,
      life: opts.life ?? 3000,
      closable: opts.closable ?? true,
      group: opts.group ?? "tr",
    });
  };

  /**
   * Generic helper if you want full control
   */
  const showToast = (
    severity: "success" | "error" | "warn" | "info",
    summary: string,
    detail?: string,
    opts: AlertOptions = {}
  ) => {
    toast.add({
      severity,
      summary,
      detail,
      life: opts.life ?? 3000,
      closable: opts.closable ?? true,
    });
  };

  return {
    successToast,
    errorToast,
    warnToast,
    infoToast,
    showToast,
  };
}
